import { NgModule } from '@angular/core';
import { NgDatepickerModule } from 'ng2-datepicker';
import { DatepickerComponent } from './datepicker.component';

@NgModule({
  imports: [
    NgDatepickerModule
  ],
  declarations: [
    DatepickerComponent
  ],
  exports: [
    DatepickerComponent
  ]
})
export class DatepickerModule {
}
